export function getStaticURL(): string {
	return window.getStaticURL || 'https://d8ejoa1fys2rk.cloudfront.net/5.0.5';
}
